import {
  PendingOrder,
  OrderSummaryStats,
  EscalationReason,
  EscalationRecipient,
  EscalationRequest,
  OrderFilters,
  OrdersResponse,
  EscalateOrderResponse,
  UpdateOrderStatusResponse,
  OrderStatus,
  OrderPriority,
  OrderTimeline,
  OrderCommunication
} from '../types/pendingOrders';

// Mock Data
const mockRestaurants = [
  {
    id: 'rest-1',
    name: 'Pizza Hut',
    phone: '+234 567 867 9089',
    email: 'pizzahut@email.com',
    address: '12 Avenue Close, Gbagdada',
    contactPerson: 'Peteri Amadu',
    location: { lat: 6.5244, lng: 3.3792 }
  },
  {
    id: 'rest-2',
    name: 'KFC Lagos',
    phone: '+234 567 867 9090',
    email: 'kfc@email.com',
    address: '45 Victoria Island, Lagos',
    contactPerson: 'James Brown',
    location: { lat: 6.4281, lng: 3.4219 }
  },
  {
    id: 'rest-3',
    name: 'Chicken Republic',
    phone: '+234 567 867 9091',
    email: 'chickenrepublic@email.com',
    address: '23 Allen Avenue, Ikeja',
    contactPerson: 'Mary Johnson',
    location: { lat: 6.6018, lng: 3.3515 }
  }
];

const mockCustomers = [
  {
    id: 'cust-1',
    name: 'John Mary',
    phone: '+234 567 867 9089',
    email: 'johnmary@email.com',
    address: '12 Avenue Close, Gbagdada',
    location: { lat: 6.5244, lng: 3.3792 }
  },
  {
    id: 'cust-2',
    name: 'Mary John',
    phone: '+234 567 867 9088',
    email: 'maryjohn@email.com',
    address: '45 Victoria Island, Lagos',
    location: { lat: 6.4281, lng: 3.4219 }
  },
  {
    id: 'cust-3',
    name: 'Peter Paul',
    phone: '+234 567 867 9087',
    email: 'peterpaul@email.com',
    address: '23 Allen Avenue, Ikeja',
    location: { lat: 6.6018, lng: 3.3515 }
  }
];

const mockRiders = [
  {
    id: 'rider-1',
    name: 'David Johnson',
    phone: '+234 567 867 9085',
    vehicleType: 'Motorcycle',
    rating: 4.5,
    location: { lat: 6.5244, lng: 3.3792 }
  },
  {
    id: 'rider-2',
    name: 'Michael Brown',
    phone: '+234 567 867 9086',
    vehicleType: 'Bicycle',
    rating: 4.2,
    location: { lat: 6.4281, lng: 3.4219 }
  }
];

const mockOrders: PendingOrder[] = [
  {
    id: 'order-1',
    orderNumber: '#FBTP123',
    customer: mockCustomers[0],
    restaurant: mockRestaurants[0],
    rider: mockRiders[0],
    items: [
      { id: 'item-1', name: 'Jollof Rice', quantity: 2, price: 2500 },
      { id: 'item-2', name: 'Pepsi Pet', quantity: 1, price: 500 },
      { id: 'item-3', name: 'Beef', quantity: 3, price: 1200 }
    ],
    total: 3400,
    status: 'preparing',
    priority: 'high',
    createdAt: new Date(Date.now() - 10 * 60 * 1000).toISOString(), // 10 minutes ago
    estimatedDeliveryTime: new Date(Date.now() + 15 * 60 * 1000).toISOString(), // 15 minutes from now
    waitingTime: 10,
    isEscalated: false,
    lastUpdated: new Date().toISOString(),
    paymentMethod: 'cash',
    paymentStatus: 'pending',
    deliveryFee: 500,
    serviceFee: 200,
    tax: 300,
    orderType: 'delivery',
    progress: 60,
    specialInstructions: 'Please ring the doorbell'
  },
  {
    id: 'order-2',
    orderNumber: '#FBTP124',
    customer: mockCustomers[0],
    restaurant: mockRestaurants[0],
    rider: mockRiders[0],
    items: [
      { id: 'item-1', name: 'Jollof Rice', quantity: 2, price: 2500 },
      { id: 'item-2', name: 'Pepsi Pet', quantity: 1, price: 500 },
      { id: 'item-3', name: 'Beef', quantity: 3, price: 1200 }
    ],
    total: 3400,
    status: 'pending',
    priority: 'normal',
    createdAt: new Date(Date.now() - 2 * 60 * 1000).toISOString(), // 2 minutes ago
    estimatedDeliveryTime: new Date(Date.now() + 23 * 60 * 1000).toISOString(), // 23 minutes from now
    waitingTime: 2,
    isEscalated: false,
    lastUpdated: new Date().toISOString(),
    paymentMethod: 'cash',
    paymentStatus: 'pending',
    deliveryFee: 500,
    serviceFee: 200,
    tax: 300,
    orderType: 'delivery',
    progress: 20
  },
  {
    id: 'order-3',
    orderNumber: '#FBTP125',
    customer: mockCustomers[0],
    restaurant: mockRestaurants[0],
    rider: mockRiders[0],
    items: [
      { id: 'item-1', name: 'Jollof Rice', quantity: 2, price: 2500 },
      { id: 'item-2', name: 'Pepsi Pet', quantity: 1, price: 500 },
      { id: 'item-3', name: 'Beef', quantity: 3, price: 1200 }
    ],
    total: 3400,
    status: 'flagged',
    priority: 'critical',
    createdAt: new Date(Date.now() - 25 * 60 * 1000).toISOString(), // 25 minutes ago
    estimatedDeliveryTime: new Date(Date.now() - 2 * 60 * 1000).toISOString(), // 2 minutes ago (overdue)
    waitingTime: 25,
    isEscalated: true,
    escalationReason: 'Order delayed beyond acceptable time',
    escalationNotes: 'Customer called multiple times asking for status update',
    escalatedTo: 'Operations Manager',
    escalatedAt: new Date(Date.now() - 5 * 60 * 1000).toISOString(),
    lastUpdated: new Date().toISOString(),
    paymentMethod: 'cash',
    paymentStatus: 'pending',
    deliveryFee: 500,
    serviceFee: 200,
    tax: 300,
    orderType: 'delivery',
    progress: 60
  },
  {
    id: 'order-4',
    orderNumber: '#FBTP126',
    customer: mockCustomers[0],
    restaurant: mockRestaurants[0],
    rider: mockRiders[0],
    items: [
      { id: 'item-1', name: 'Jollof Rice', quantity: 2, price: 2500 },
      { id: 'item-2', name: 'Pepsi Pet', quantity: 1, price: 500 },
      { id: 'item-3', name: 'Beef', quantity: 3, price: 1200 }
    ],
    total: 3400,
    status: 'escalated',
    priority: 'critical',
    createdAt: new Date(Date.now() - 30 * 60 * 1000).toISOString(), // 30 minutes ago
    estimatedDeliveryTime: new Date(Date.now() - 7 * 60 * 1000).toISOString(), // 7 minutes ago (overdue)
    waitingTime: 30,
    isEscalated: true,
    escalationReason: 'Restaurant not responding',
    escalationNotes: 'Multiple calls to restaurant went unanswered',
    escalatedTo: 'Senior Manager',
    escalatedAt: new Date(Date.now() - 10 * 60 * 1000).toISOString(),
    lastUpdated: new Date().toISOString(),
    paymentMethod: 'cash',
    paymentStatus: 'pending',
    deliveryFee: 500,
    serviceFee: 200,
    tax: 300,
    orderType: 'delivery',
    progress: 40
  }
];

const mockEscalationReasons: EscalationReason[] = [
  {
    id: 'reason-1',
    name: 'Delay',
    description: 'Order is experiencing delays in preparation or delivery',
    severity: 'high'
  },
  {
    id: 'reason-2',
    name: 'Weather Issues',
    description: 'Weather conditions are affecting order delivery',
    severity: 'medium'
  }
];

const mockEscalationRecipients: EscalationRecipient[] = [
  {
    id: 'recipient-1',
    name: 'Restaurants',
    role: 'Restaurant Partner',
    department: 'Restaurant Operations',
    email: 'restaurants@foodbank.com',
    phone: '+234 567 867 9000'
  },
  {
    id: 'recipient-2',
    name: 'Customer',
    role: 'Customer Support',
    department: 'Customer Service',
    email: 'customer.support@foodbank.com',
    phone: '+234 567 867 9001'
  }
];

// Service functions
class PendingOrdersService {
  private orders: PendingOrder[] = [...mockOrders];
  private escalationReasons: EscalationReason[] = [...mockEscalationReasons];
  private escalationRecipients: EscalationRecipient[] = [...mockEscalationRecipients];

  // Simulate API delay
  private async delay(ms: number = 800): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async getOrders(filters?: OrderFilters): Promise<OrdersResponse> {
    await this.delay();

    let filteredOrders = [...this.orders];

    // Apply filters
    if (filters) {
      if (filters.status?.length) {
        filteredOrders = filteredOrders.filter(order => 
          filters.status!.includes(order.status)
        );
      }

      if (filters.priority?.length) {
        filteredOrders = filteredOrders.filter(order => 
          filters.priority!.includes(order.priority)
        );
      }

      if (filters.restaurant?.length) {
        filteredOrders = filteredOrders.filter(order => 
          filters.restaurant!.includes(order.restaurant.id)
        );
      }

      if (filters.customer) {
        filteredOrders = filteredOrders.filter(order => 
          order.customer.name.toLowerCase().includes(filters.customer!.toLowerCase()) ||
          order.customer.phone.includes(filters.customer!)
        );
      }

      if (filters.isEscalated !== undefined) {
        filteredOrders = filteredOrders.filter(order => 
          order.isEscalated === filters.isEscalated
        );
      }

      if (filters.waitTimeRange) {
        filteredOrders = filteredOrders.filter(order => 
          order.waitingTime >= filters.waitTimeRange!.min &&
          order.waitingTime <= filters.waitTimeRange!.max
        );
      }
    }

    const stats: OrderSummaryStats = {
      totalPending: this.orders.filter(o => ['pending', 'preparing', 'ready'].includes(o.status)).length,
      lateOrders: this.orders.filter(o => 
        new Date(o.estimatedDeliveryTime) < new Date() && 
        !['delivered', 'cancelled'].includes(o.status)
      ).length,
      escalated: this.orders.filter(o => o.isEscalated).length,
      averageWaitTime: Math.round(
        this.orders.reduce((acc, o) => acc + o.waitingTime, 0) / this.orders.length
      ),
      totalRevenue: this.orders.reduce((acc, o) => acc + o.total, 0),
      completionRate: 85.5
    };

    return {
      success: true,
      data: filteredOrders,
      stats,
      message: 'Orders fetched successfully'
    };
  }

  async getOrderById(id: string): Promise<PendingOrder | null> {
    await this.delay(300);
    return this.orders.find(order => order.id === id) || null;
  }

  async updateOrderStatus(id: string, status: OrderStatus): Promise<UpdateOrderStatusResponse> {
    await this.delay(500);

    const orderIndex = this.orders.findIndex(order => order.id === id);
    if (orderIndex === -1) {
      return {
        success: false,
        data: null as any,
        error: 'Order not found'
      };
    }

    // Update order status and progress
    this.orders[orderIndex] = {
      ...this.orders[orderIndex],
      status,
      lastUpdated: new Date().toISOString(),
      progress: this.getProgressByStatus(status)
    };

    return {
      success: true,
      data: this.orders[orderIndex],
      message: 'Order status updated successfully'
    };
  }

  async escalateOrder(request: EscalationRequest): Promise<EscalateOrderResponse> {
    await this.delay(1000);

    const orderIndex = this.orders.findIndex(order => order.id === request.orderId);
    if (orderIndex === -1) {
      return {
        success: false,
        data: null as any,
        error: 'Order not found'
      };
    }

    const reason = this.escalationReasons.find(r => r.id === request.reasonId);
    const recipient = this.escalationRecipients.find(r => r.id === request.recipientId);

    // Update order with escalation info
    const escalationId = `ESC-${Date.now()}`;
    this.orders[orderIndex] = {
      ...this.orders[orderIndex],
      status: 'escalated',
      priority: request.priority,
      isEscalated: true,
      escalationReason: reason?.name || 'Unknown reason',
      escalationNotes: request.additionalNotes,
      escalatedTo: recipient?.name || 'Unknown recipient',
      escalatedAt: new Date().toISOString(),
      lastUpdated: new Date().toISOString()
    };

    return {
      success: true,
      data: {
        orderId: request.orderId,
        escalationId,
        escalatedAt: new Date().toISOString()
      },
      message: 'Order escalated successfully'
    };
  }

  async getEscalationReasons(): Promise<EscalationReason[]> {
    await this.delay(200);
    return [...this.escalationReasons];
  }

  async getEscalationRecipients(): Promise<EscalationRecipient[]> {
    await this.delay(200);
    return [...this.escalationRecipients];
  }

  async getOrderTimeline(orderId: string): Promise<OrderTimeline[]> {
    await this.delay(300);
    
    // Mock timeline data
    return [
      {
        id: 'timeline-1',
        orderId,
        status: 'pending',
        timestamp: new Date(Date.now() - 30 * 60 * 1000).toISOString(),
        description: 'Order created and waiting for restaurant acceptance',
        actor: 'System',
        actorType: 'system'
      },
      {
        id: 'timeline-2',
        orderId,
        status: 'accepted',
        timestamp: new Date(Date.now() - 25 * 60 * 1000).toISOString(),
        description: 'Order accepted by restaurant',
        actor: 'Pizza Hut',
        actorType: 'restaurant'
      },
      {
        id: 'timeline-3',
        orderId,
        status: 'preparing',
        timestamp: new Date(Date.now() - 20 * 60 * 1000).toISOString(),
        description: 'Restaurant started preparing the order',
        actor: 'Pizza Hut',
        actorType: 'restaurant'
      }
    ];
  }

  async getOrderCommunications(orderId: string): Promise<OrderCommunication[]> {
    await this.delay(300);
    
    // Mock communication data
    return [
      {
        id: 'comm-1',
        orderId,
        type: 'call',
        direction: 'outbound',
        participant: 'John Mary',
        participantType: 'customer',
        content: 'Called customer to confirm delivery address',
        timestamp: new Date(Date.now() - 10 * 60 * 1000).toISOString(),
        status: 'delivered'
      },
      {
        id: 'comm-2',
        orderId,
        type: 'sms',
        direction: 'outbound',
        participant: 'John Mary',
        participantType: 'customer',
        content: 'Order status update: Your order is being prepared',
        timestamp: new Date(Date.now() - 20 * 60 * 1000).toISOString(),
        status: 'delivered'
      }
    ];
  }

  // Helper method to get progress percentage by status
  private getProgressByStatus(status: OrderStatus): number {
    const progressMap: Record<OrderStatus, number> = {
      'pending': 10,
      'accepted': 20,
      'preparing': 40,
      'ready': 60,
      'picked_up': 70,
      'in_transit': 85,
      'delivered': 100,
      'cancelled': 0,
      'flagged': 60,
      'escalated': 50
    };
    return progressMap[status] || 0;
  }

  // Simulate real-time updates
  startRealTimeUpdates(callback: (orders: PendingOrder[]) => void): () => void {
    const interval = setInterval(() => {
      // Randomly update waiting times
      this.orders = this.orders.map(order => {
        if (!['delivered', 'cancelled'].includes(order.status)) {
          const updatedOrder = {
            ...order,
            waitingTime: order.waitingTime + 1,
            lastUpdated: new Date().toISOString()
          };

          // Auto-escalate orders that are very late
          if (updatedOrder.waitingTime > 45 && !updatedOrder.isEscalated && updatedOrder.priority !== 'critical') {
            return {
              ...updatedOrder,
              isEscalated: true,
              escalationReason: 'Auto-escalated due to excessive wait time',
              escalatedTo: 'Operations Manager',
              escalatedAt: new Date().toISOString(),
              priority: 'high' as OrderPriority,
              status: 'escalated' as OrderStatus
            };
          }
          
          return updatedOrder;
        }
        return order;
      });

      callback([...this.orders]);
    }, 60000); // Update every minute

    return () => clearInterval(interval);
  }
}

export const pendingOrdersService = new PendingOrdersService();
export default pendingOrdersService;